import React from 'react';
import cx from 'classnames';

import styles from './Divider.module.scss';
import usePresenter from './Divider.presenter';
import getProps from './Divider.props';
import { DividerCombinedProps } from './types';

const Divider: React.FC<DividerCombinedProps> = (props) => {
  const {
    type,
    colour,
    className,
    classes,
  } = usePresenter(props);

  const variantName = `${type}${colour}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`divider${variantName}`];

  let componentView;

  switch (variantName) {
    case 'HorizontalNeutral1900':
    case 'HorizontalNeutralBG2':
    case 'HorizontalNeutralBG3':
    case 'VerticalNeutral1900': {
      componentView = (
        <div className={cx(currentStyle, className)} />
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default Divider;
